/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================
* Birth data step: Birth Date, Birth Time, Birth Place
=========================================================
*/

import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { Field } from "formik";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftDatePicker from "components/SoftDatePicker";
import SoftTimePicker from "components/SoftTimePicker";
import FormField from "layouts/pages/users/new-user/components/FormField";

function BirthData({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { birthDate, birthTime, birthPlace } = formField;
  const {
    birthDate: birthDateV,
    birthTime: birthTimeV,
    birthPlace: birthPlaceV,
  } = values;

  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          Birth data
        </SoftTypography>
        <SoftTypography variant="button" fontWeight="regular" color="text">
          Date, time and place of birth (all required)
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftBox mb={1.5}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {birthDate.label}
                </SoftTypography>
              </SoftBox>
              <Field name={birthDate.name}>
                {({ field, form }) => (
                  <SoftDatePicker
                    value={field.value || null}
                    onChange={([selectedDate], dateStr) => {
                      form.setFieldValue(birthDate.name, dateStr || "");
                    }}
                    options={{ dateFormat: "Y-m-d" }}
                  />
                )}
              </Field>
              {errors.birthDate && touched.birthDate && (
                <SoftBox mt={0.75}>
                  <SoftTypography component="div" variant="caption" color="error">
                    {errors.birthDate}
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftBox mb={1.5}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {birthTime.label}
                </SoftTypography>
              </SoftBox>
              <Field name={birthTime.name}>
                {({ field, form }) => (
                  <SoftTimePicker
                    value={field.value || ""}
                    onChange={([], dateStr) => {
                      form.setFieldValue(birthTime.name, dateStr || "");
                    }}
                  />
                )}
              </Field>
              {errors.birthTime && touched.birthTime && (
                <SoftBox mt={0.75}>
                  <SoftTypography component="div" variant="caption" color="error">
                    {errors.birthTime}
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField
              type={birthPlace.type}
              label={birthPlace.label}
              name={birthPlace.name}
              value={birthPlaceV}
              placeholder={birthPlace.placeholder}
              error={errors.birthPlace && touched.birthPlace}
              success={birthPlaceV.length > 0 && !errors.birthPlace}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

BirthData.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default BirthData;
